import { Component, inject } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { AlertMessage, AlertService } from '../../services/alert.service'
import { toSignal } from '@angular/core/rxjs-interop'

export type AlertType = 'success' | 'error' | 'info' | 'warning'

@Component({
  selector: 'app-alert',
  imports: [MatIconModule],
  template: `
    @if (alert()) {
      <div
        class="fixed top-4 right-4 z-[1100] flex items-start gap-3 w-100 p-4 rounded-lg shadow-lg border-l-4 transition-opacity duration-200 ease-out"
        [attr.role]="alert()!.type === 'error' ? 'alert' : 'status'"
        [class.bg-red-50]="alert()!.type === 'error'"
        [class.text-red-800]="alert()!.type === 'error'"
        [class.border-red-400]="alert()!.type === 'error'"
        [class.bg-blue-50]="alert()!.type === 'info'"
        [class.text-blue-800]="alert()!.type === 'info'"
        [class.border-blue-400]="alert()!.type === 'info'"
        [class.bg-green-50]="alert()!.type === 'success'"
        [class.text-green-800]="alert()!.type === 'success'"
        [class.border-green-400]="alert()!.type === 'success'"
        [class.bg-orange-50]="alert()!.type === 'warning'"
        [class.text-orange-800]="alert()!.type === 'warning'"
        [class.border-orange-400]="alert()!.type === 'warning'"
      >
        <mat-icon class="!w-6 !h-6 !text-current">{{ getIcon() }}</mat-icon>
        <div class="flex-1">
          @if (alert()!.title) {
            <div class="font-semibold mb-1">{{ alert()!.title }}</div>
          }
          <div class="text-sm leading-5">{{ alert()!.message }}</div>
        </div>
        <button
          class="ml-2 text-current hover:opacity-70 transition-opacity text-xl cursor-pointer"
          (click)="dismiss()"
          aria-label="Close alert"
        >
          ✕
        </button>
      </div>
    }
  `,
})
export class AlertComponent {
  private alertService = inject(AlertService)
  alert = toSignal<AlertMessage | null>(this.alertService.alert$, {
    initialValue: null,
  })

  getIcon(): string {
    if (!this.alert()) return ''
    switch (this.alert()!.type) {
      case 'success':
        return 'check_circle'
      case 'error':
        return 'error'
      case 'warning':
        return 'warning'
      default:
        return 'info'
    }
  }

  dismiss() {
    this.alertService.clear()
  }
}
